import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Spinner } from '@src/components';
import { FullPageShell } from '@src/components/FullPageShell/FullPageShell';
import { useAppSelector } from '@src/state/hooks';
import { LOGIN_PATH } from '@src/routing/routes';
import { NotificationsList } from './NotificationsList';

export function NotificationsPage() {
  const { t } = useTranslation();
  const { user, status } = useAppSelector((state) => state.session);
  if (status === 'idle' || status === 'loading')
    return <Spinner label={t('notifications.loading')} />;
  if (!user) return <Navigate to={LOGIN_PATH} replace />;
  return (
    <FullPageShell
      title={t('notifications.title')}
      testId="notifications-page"
      backTestId="notifications-back"
    >
      <NotificationsList />
    </FullPageShell>
  );
}
